import { useState } from "react";
import { loginPassenger } from "../../services/login";
import regex from "../../utils/regex";
import Swal from "sweetalert2";
import { setLoggedUser } from "../../redux/userSlice";
import { useSelector, useDispatch } from "react-redux";
import { registerPassenger } from "../../services/register";
import logo from "../../imgs/TuViajeLogo1.png";

import "./styles.css";
import { LoginNavBar } from "../MainInformation/NavBar/LoginNavBar";
import { Link, NavLink } from "react-router-dom";
import { LottieAnimation } from "../LottieAnimation/LottieAnimation";
export const Login = () => {
  const dispatch = useDispatch();

  const [deslizado, setDeslizado] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [registerUser, setRegisterUser] = useState("");
  const [registerEmail, setRegisterEmail] = useState("");
  const [registerPassword, setRegisterPassword] = useState("");
  const [registerConfirmPassword, setRegisterConfirmPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showRegisterPassword, setShowRegisterPassword] = useState(false);
  const [showRegisterConfirmPassword, setShowRegisterConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);


  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleLoginClick();
    }
  };

  const handleKeyDownRegister = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleRegisterClick();
    }
  }

  const handleDeslizar = () => {
    setDeslizado(!deslizado);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000); // Cambia el tiempo según tus necesidades (en milisegundos)
  };



  const handleLoginClick = () => {
    if (regex.regexEmail.test(email) && regex.regexPassword.test(password)) {
      // console.log("email", email, "password", password);

      loginPassenger(email, password)
        .then((userData) => {
          dispatch(
            setLoggedUser({
              role: userData.profile,
              logged: true,
              id: userData.id,
              names: userData.names,
              lastName: userData.lastName,
              email: userData.email,
              phone: userData.phone,
              tokenPush: userData.token,
              status: userData.status,
              profile: userData.profile,
            })
          );

          Swal.fire({
            title: "Sesión abierta correctamente",
            icon: "success",
            showConfirmButton: false,
            timer: 1500
          });


        })
        .catch((error) => {
          console.error("Error en el inicio de sesión:", error);
          Swal.fire({
            icon: "error",
            title: "¡ERROR!",
            text: "Datos Incorrectos",
          });
        }).finally(() => {
        }
        );
    } else {
      if (!regex.regexEmail.test(email)) {
        Swal.fire({
          icon: "error",
          title: "¡ERROR!",
          text: "Correo electrónico inválido. Por favor, ingresa un correo válido.",
        });
      } else if (!regex.regexPassword.test(password)) {
        Swal.fire({
          icon: "error",
          title: "¡ERROR!",
          text: "Contraseña inválida. caracteres validos:  *-_@ .  Por favor, ingresa una contraseña válida.",
        });
      }
    }
  };


  const formLogin = () => {

    return (
      <div className="login_item_Form_container">

        <div className="login_item">
          <div>
            <input
              className="login_item_input"
              type="text"
              placeholder="Email"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <input
              className="login_item_input"
              type={showPassword ? "text" : "password"}
              placeholder="Contraseña"
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <ion-icon
              className="toggle-password-icon"
              name={showPassword ? "eye-off-outline" : "eye-outline"}
              onClick={() => setShowPassword(!showPassword)}
            ></ion-icon>
          </div>

          <div className="login_item_forgot_password"> 
        <Link
          className="login_item_forgot_password_link"
          onClick={() => {
          Swal.fire({
            icon: "info",
            title: "Estamos trabajando en esto",
            text: "Pronto estará en funcionamiento.",
          });
          }}
        >
          ¿Olvidaste tu contraseña?
        </Link>
        </div>
          <div className="login_item_button">
            <button
              className="login_item_one_button"
              onClick={() => {
                handleLoginClick();
              }}
            >
              Ingresar
            </button>
          </div>
        </div>
      </div>
    );
  };

  const formRegister = () => {
    return (
      <div className="login_item">
        <div>
          <input
            className="login_item_input"
            type="text"
            placeholder="Nombre"
            onChange={(e) => setRegisterUser(e.target.value)}
          />
        </div>
        <div>
          <input
            className="login_item_input"
            type="text"
            placeholder="Email"
            onChange={(e) => setRegisterEmail(e.target.value)}
          />
        </div>
        <div>
          <input
            className="login_item_input"
            type={showRegisterPassword ? "text" : "password"}
            placeholder="Contraseña"
            onChange={(e) => setRegisterPassword(e.target.value)}
            onKeyDown={handleKeyDownRegister}
          />
          <ion-icon
            className="toggle-password-icon"
            name={showRegisterPassword ? "eye-off-outline" : "eye-outline"}
            onClick={() => setShowRegisterPassword(!showRegisterPassword)}
          ></ion-icon>
        </div>
        <div>
          <input
            className="login_item_input"
            type={showRegisterConfirmPassword ? "text" : "password"}
            placeholder="Confirmar contraseña"
            onChange={(e) => setRegisterConfirmPassword(e.target.value)}
            onKeyDown={handleKeyDownRegister}
          />
          <ion-icon
            className="toggle-password-icon"
            name={showRegisterConfirmPassword ? "eye-off-outline" : "eye-outline"}
            onClick={() => setShowRegisterConfirmPassword(!showRegisterConfirmPassword)}
          ></ion-icon>
        </div>
        <div className="login_item_button">
          <button
            className="login_item_one_button"
            onClick={() => {
              handleRegisterClick();
            }}
          >
            Registrar
          </button>
        </div>
      </div>
    );
  };

  const handleRegisterClick = () => {
    // console.log(
    //   "ENTRANDO A REGISTRAR",
    //   registerEmail,
    //   registerPassword,
    //   registerUser,
    //   registerConfirmPassword
    // );

    if (
      regex.regexName.test(registerUser) &&
      regex.regexEmail.test(registerEmail) &&
      regex.regexPassword.test(registerPassword) &&
      regex.regexPassword.test(registerConfirmPassword) &&
      registerPassword === registerConfirmPassword
    ) {
      // console.log("email", registerEmail, "password", registerPassword);
      registerPassenger(registerUser, registerEmail, registerPassword)
        .then((registerData) => {
          // console.log("registerData", registerData);

          Swal.fire({
            icon: "success",
            title: "¡ÉXITO!",
            text: "Registro exitoso",
            timer: 1500,
            showConfirmButton: false,
          });

          loginPassenger(registerEmail, registerPassword)
            .then((userData) => {
              dispatch(
                setLoggedUser({
                  role: userData.profile,
                  logged: true,
                  id: userData.id,
                  names: userData.names,
                  lastName: userData.lastName,
                  email: userData.email,
                  phone: userData.phone,
                  tokenPush: userData.token,
                  status: userData.status,
                  profile: userData.profile,
                })
              );
            })
            .catch((error) => {
              console.error("Error en el inicio de sesión:", error);
              Swal.fire({
                icon: "error",
                title: "¡ERROR!",
                text: "Datos Incorrectos",
              });
            });
        })
        .catch((error) => {
          console.error(
            "Error en el registro:",
            error,
            "registerUser",
            registerUser,
            "registerEmail",
            registerEmail,
            "registerPassword",
            registerPassword,
            "registerConfirmPassword",
            registerConfirmPassword
          );

          Swal.fire({
            icon: "error",
            title: "¡ERROR!",
            text: `${error} `,
          });
        });
    } else {
      if (!regex.regexName.test(registerUser)) {
        Swal.fire({
          icon: "error",
          title: "¡ERROR!",
          text: "Nombre inválido. Por favor, ingresa un nombre válido.",
        });
      } else if (!regex.regexEmail.test(registerEmail)) {
        Swal.fire({
          icon: "error",
          title: "¡ERROR!",
          text: "Correo electrónico inválido. Por favor, ingresa un correo válido.",
        });
      } else if (!regex.regexPassword.test(registerPassword)) {
        Swal.fire({
          icon: "error",
          title: "¡ERROR!",
          text: "Contraseña inválida. Caracteres especiales válidos: *-_@ Por favor, ingresa una contraseña válida de 5 a 10 caracteres.",
        });
      }
      else if (registerPassword !== registerConfirmPassword) {
        Swal.fire({
          icon: "error",
          title: "¡ERROR!",
          text: "Las contraseñas no coinciden. Por favor, ingresa una contraseña válida.",
        });
      }
    }
  };

  return (
    <div className="container_login">
      <LoginNavBar />
      <div className="container_children_login">
      <div className="background_blur" />
        <div className="container_login_title">
          <button
            className="Login_buttoonBack"
            onClick={() => {
              window.location.href = "/";
            }}
          >
            <ion-icon className="login_button" name="arrow-back-outline"></ion-icon>
            Volver
          </button>
          <NavLink to="/politicas" className="subtitle_login">
            Términos y condiciones
          </NavLink>
        </div>

        <div className="login_item_row">
          {loading ? (
           <LottieAnimation  
           height={200} 
             width={200}
              containerHeight="50vh"
              containerWidth="50%"
              position="relative"
             
           />
          ) : (
            /* Contenedor del formulario (izquierda) */
            <div className="Foms_login_change">
              <img src={logo} alt="Logo" />
              <div className="container_selects_login">
                <Link className="subtitle_login_Register" onClick={handleDeslizar}>
                  {deslizado ? "Inicia sesión" : "Regístrate"}
                </Link>
              </div>
              {deslizado ? formRegister() : formLogin()}
            </div>
          )}
          {/* Contenedor de la imagen (derecha) */}
          <div className="login_images_container">
            <img />
          </div>
        </div>
      </div>
    </div>
  );
};
